// eslint-disable-next-line @typescript-eslint/no-explicit-any
type IsTypeFunctionType<T> = (obj: any) => obj is T;

export type ObjectKeyType = string | number | symbol;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ObjectType = Record<ObjectKeyType, any>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getType = (obj: any): string => (
  Object.prototype.toString.call(obj).slice(8, -1)
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isTypeOf = (obj: any, typeName: string): boolean => getType(obj) === typeName;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isArray: IsTypeFunctionType<Array<any>> = (obj): obj is Array<any> => (
  isTypeOf(obj, 'Array')
);
export const isFile: IsTypeFunctionType<File> = (obj): obj is File => (
  obj instanceof File
);
export const isFormData: IsTypeFunctionType<FormData> = (obj): obj is FormData => (
  obj instanceof FormData
);
export const isNumber: IsTypeFunctionType<number> = (obj): obj is number => (
  isTypeOf(obj, 'Number')
);
export const isObject: IsTypeFunctionType<ObjectType> = (obj): obj is ObjectType => (
  isTypeOf(obj, 'Object') && obj !== null
);
export const isString: IsTypeFunctionType<string> = (obj): obj is string => (
  isTypeOf(obj, 'String')
);
